import { KeyboardBackspace } from "@mui/icons-material";
import { Box, IconButton, Sheet, Stack, Typography } from "@mui/joy";
import { useNavigate } from "react-router";

const HeaderBackButton = ({ title }) => {
  const navigate = useNavigate();
  return (
    <>
      <Sheet
        sx={{
          display: "flex",
          alignItems: "center",
          //justifyContent: "space-between",
          position: "sticky",
          top: 0,
          width: "100vw",
          height: "var(--Header-height)",
          zIndex: 9995,
          padding: "10px 10px",
          borderBottom: "1px solid",
          borderColor: "background.level1",
         
        }}
        variant="outlined"
      >
        <IconButton onClick={() => navigate(-1)} size="lg" variant="plain">
          <KeyboardBackspace fontSize="xl2" />
        </IconButton>
        <Box ml={2}>
          <Typography>{title}</Typography>
        </Box>
      </Sheet>
      <Box mt={4} />
    </>
  );
};

export default HeaderBackButton;
